export interface IAdsState {
  slots: string[]|null;
  slotsIsLoading: boolean;
  slotsError: Error | null;
}

const defaultState: IAdsState = {
  slots: [],
  slotsIsLoading: false,
  slotsError: null,
};

export const getDefaultAdsState = () => defaultState;
